import classNames from 'classnames';
import React from 'react';
import PaymentRow from './PaymentRow';

export const PaymentsTable = ({ payments = [], intl }) => {
  return (
    <div className='payments-table'>
      {payments.map((payment, i) => (
        <div
          className={classNames({
            'margin-xl-top': i > 0
          })}
        >
          <PaymentRow payment={payment} intl={intl} />
        </div>
      ))}
    </div>
  );
};
